export const defaultAppConfig = {
  app_name: "PromptHub",
  app_description: "PromptHub is a collaborative web application designed to help AI power-users, teams, and educators create, organize, publish, and share multi-message AI prompts in a unified workspace. Dynamic variables and rich tag-based search streamline prompt reuse across contexts. Role-based permissions and organization support ensure secure collaboration, while public publishing fosters community-driven discovery.",
  app_tagline: "Your Command Center for AI Prompts",
  production: process.env.NODE_ENV === "production",
  app_url: process.env.APP_URL || "",
  app_id: process.env.APP_ID || "",
  
  app_logo_url_light:
    "https://app-assets.constructr.ai/2784816b-5201-4b98-92c0-7a9975ab6e11/branding/logo-light.png",
  app_logo_url_dark:
    "https://app-assets.constructr.ai/2784816b-5201-4b98-92c0-7a9975ab6e11/branding/logo-dark.png",

  app_full_logo_url_light:
    "https://app-assets.constructr.ai/2784816b-5201-4b98-92c0-7a9975ab6e11/branding/logo-full-light.png",
  app_full_logo_url_dark:
    "https://app-assets.constructr.ai/2784816b-5201-4b98-92c0-7a9975ab6e11/branding/logo-full-dark.png",

  app_badge_show: true,
  app_badge_href: "https://constructr.ai?utm_source=badge&utm_campaign=badge",
  app_badge_src: "https://assets.constructr.ai/images/made-with-badge.png",
  app_badge_alt: "Made with Constructr",
  allow_remix: false
};



